import { Link } from 'react-router-dom'
import { listMockProjectIds } from '../mock/fixtures'
import { Play, ArrowRight } from 'lucide-react'

export default function HomePage() {
  const projectIds = listMockProjectIds()
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="mb-12">
        <div className="inline-flex items-center gap-2 rounded-full bg-ub-blue-50 px-3 py-1 text-xs font-medium text-ub-blue-800 mb-4">
          <span className="h-1.5 w-1.5 rounded-full bg-ub-blue-500" />
          STAGING
        </div>
        <h1 className="text-4xl font-bold tracking-tight text-slate-900 mb-4">
          UB Video Player Artifact
        </h1>
        <p className="text-lg text-slate-600 leading-relaxed">
          Every UB video-edit project has a stable public URL that auto-updates
          as the AI ships new versions. The end user never reopens anything.
          Their tab quietly refreshes.
        </p>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-6">
        <h2 className="text-sm font-semibold text-slate-500 uppercase tracking-wide mb-4">
          Fixture projects
        </h2>
        <ul className="space-y-2">
          {projectIds.map((id) => (
            <li key={id}>
              <Link
                to={`/v/${id}`}
                className="flex items-center justify-between rounded-xl border border-slate-200 px-4 py-3 hover:border-ub-blue-400 hover:bg-ub-blue-50 transition group"
              >
                <div className="flex items-center gap-3">
                  <div className="rounded-lg bg-ub-blue-100 p-2 text-ub-blue-700">
                    <Play className="h-4 w-4" fill="currentColor" />
                  </div>
                  <div>
                    <div className="font-medium text-slate-900">/v/{id}</div>
                    <div className="text-xs text-slate-500">Mocked project with three ready versions</div>
                  </div>
                </div>
                <ArrowRight className="h-4 w-4 text-slate-400 group-hover:text-ub-blue-600 transition" />
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-8 text-xs text-slate-500 leading-relaxed">
        <p>
          This is a staging surface. Backend is mocked; all versions and SSE
          events come from <code className="rounded bg-slate-100 px-1">src/mock/</code>.
          Open a project above and wait about 8 seconds to see a new version
          arrive via the mocked SSE stream.
        </p>
      </div>
    </div>
  )
}
